import { useState } from "react";

const initialFilter = {
  logic: "and",
  filters: [],
};

const initialDataState = {
  skip: 0,
  take: 10,
};

export default function useKendoGridState(sortField, sortDir = "desc") {
  const [sort, setSort] = useState([{ field: sortField, dir: sortDir }]);
  const [filter, setFilter] = useState(initialFilter);
  const [page, setPage] = useState(initialDataState);

  const pageChange = (event) => {
    setPage(event.page);
  };

  return { sort, setSort, filter, setFilter, page, setPage, pageChange };
}
